/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { MessageFormFields, MessageType } from './types';

export const SUBJECT_MAX_LENGTH = 100;
export const MESSAGE_MAX_LENGTH = 240;

export const isSubjectValid = (subject: string | undefined) => {
  if (subject === undefined) {
    return false;
  }
  const len = subject.length;
  return (len > 0 && len <= SUBJECT_MAX_LENGTH);
}

export const isMessageValid = (message: string | undefined) => {
  if (message === undefined) {
    return false;
  }
  const len = message.length;
  return (len > 0 && len <= MESSAGE_MAX_LENGTH);
}

export const isUserIdsValid = (userIds: string[]) => {
  const len = userIds.length;
  return (len > 0 && userIds[0].length > 0);
}

export const isFormValid = (type: MessageType, form: MessageFormFields): boolean => {

  if (type === MessageType.User) {
    if (!isUserIdsValid(form.userIds)) {
      return false;
    }
  } else {
    if (!isUserIdsValid(form.contributorIds) && !isUserIdsValid(form.verifierIds)) {
      return false;
    }
  }

  if (!isSubjectValid(form.subject)) {
    return false;
  }
  if (!isMessageValid(form.message)) {
    return false;
  }
  return true;
}
